var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDeafultImg(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 57,
    height: 57,
    fill: "none",
    viewBox: "0 0 57 57",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 56.17,
    height: 56.17,
    fill: "#FF0004",
    rx: 28.085
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M20.48 20.083c0-4.146 3.373-7.52 7.52-7.52s7.52 3.374 7.52 7.52c0 4.147-3.373 7.521-7.52 7.521s-7.52-3.374-7.52-7.52m12.27 9.896h-9.5c-5.02 0-9.104 4.085-9.104 9.104a4.36 4.36 0 0 0 4.354 4.355h19a4.36 4.36 0 0 0 4.354-4.355c0-5.019-4.085-9.104-9.104-9.104"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeafultImg);
export default __webpack_public_path__ + "static/media/deafult_img.61ce0e1ab08af294c7362501f0c09255.svg";
export { ForwardRef as ReactComponent };